// extracted by mini-css-extract-plugin
export var askAiIcon = "_ks-9";
export var container = "_ks-0";
export var groupSeparator = "_ks-a";
export var highlight = "_ks-4";
export var resultIcon = "_ks-5";
export var resultItem = "_ks-7";
export var resultSubtitle = "_ks-3";
export var resultTitle = "_ks-2";
export var resultsList = "_ks-1";
export var searchGroup = "_ks-6";
export var selected = "_ks-8";